(() => {
  // Poster-first: no video download for reduced-motion or data-saving visitors.
  // Autoplay is attempted only for this silent, inline film, never with sound.
  function initCampaign(root = document) {
    const video = root.querySelector('[data-campaign-video]');
    if (!video || video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    const toggle = video.closest('.film-campaign').querySelector('.film-toggle');
    const label = toggle.querySelector('.film-toggle-label');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let inView = true;
    let activated = false;
    let autoResume = !reducedMotion.matches && !navigator.connection?.saveData;
    const updateControl = () => {
      const playing = !video.paused;
      toggle.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-label', playing ? 'Pause campaign film' : 'Play campaign film');
      label.textContent = playing ? 'Pause' : 'Play';
    };
    const play = async () => {
      if (!activated) { video.src = video.dataset.src; video.muted = true; activated = true; }
      try { await video.play(); } catch { updateControl(); }
    };
    toggle.hidden = false;
    video.addEventListener('playing', () => { video.classList.add('is-ready'); updateControl(); });
    video.addEventListener('pause', updateControl);
    video.addEventListener('error', () => { video.classList.remove('is-ready'); updateControl(); });
    toggle.addEventListener('click', () => {
      if (video.paused) { userPaused = false; autoResume = true; play(); }
      else { userPaused = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (!inView) video.pause();
        else if (autoResume && !userPaused && !document.hidden) play();
      }, {threshold: 0.15});
      observer.observe(video);
    } else if (autoResume) play();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
      else if (inView && autoResume && !userPaused) play();
    });
    reducedMotion.addEventListener('change', () => {
      autoResume = !reducedMotion.matches && !navigator.connection?.saveData;
      if (reducedMotion.matches) video.pause();
    });
  }
  initCampaign();
  document.addEventListener('shopify:section:load', event => initCampaign(event.target));
  const menu = document.querySelector('.mobile-menu');
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
  const mainImage = document.querySelector('.main-product-image');
  function showImage(src, alt) { if (!mainImage || !src) return; mainImage.removeAttribute('srcset'); mainImage.src = src; if (alt) mainImage.alt = alt; }
  document.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => { showImage(button.dataset.galleryImage, button.dataset.galleryAlt); document.querySelectorAll('[data-gallery-image]').forEach(other => other.setAttribute('aria-pressed', String(other === button))); }));
  const select = document.getElementById('VariantSelect');
  const options = document.getElementById('OptionSelectors');
  const variantData = document.getElementById('ProductVariants');
  if (!select || !options || !variantData) return;
  const variants = JSON.parse(variantData.textContent);
  const add = document.getElementById('AddToBag');
  const status = document.getElementById('VariantStatus');
  const price = document.querySelector('[data-product-price]');
  const groups = [...options.querySelectorAll('fieldset')];
  function update(variant) {
    const option = variant && [...select.options].find(item => item.value === String(variant.id));
    if (option) { select.value = option.value; select.disabled = false; price.textContent = option.dataset.price; showImage(option.dataset.image); const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    else select.disabled = true;
    add.disabled = !variant?.available;
    add.textContent = variant?.available ? 'ADD TO BAG' : 'CURRENTLY UNAVAILABLE';
    status.textContent = !variant ? 'This color and size combination is not offered.' : variant.available ? 'Available from our supplier' : 'This variant is currently unavailable.';
  }
  options.hidden = false;
  select.classList.add('visually-hidden');
  document.querySelector('.variant-label').classList.add('visually-hidden');
  select.tabIndex = -1;
  groups.forEach(group => group.addEventListener('change', () => { const selected = groups.map(field => field.querySelector('input:checked')?.value); update(variants.find(variant => variant.options.every((value, index) => value === selected[index]))); }));
  document.getElementById('ProductForm').addEventListener('submit', event => { if (add.disabled || select.disabled) { event.preventDefault(); status.focus(); } });
})();
